import type { ListBuilderList } from '../../../types';
import { createSensorDeviceColumns } from '../columns';

/**
 * All Sensor Devices list (PD-13926) — backed by the sensor_device entity
 * (/api/sensor-devices). Devices are auto-created on ingestion; this list
 * surfaces device health, attachment, and sensor coverage.
 */
export const allSensorDevicesList: ListBuilderList = {
	id: 'default-sensor-devices',
	name: 'All Devices',
	type: 'default',
	active: true,
	cacheTTL: 600000,
	columns: createSensorDeviceColumns(),
	defaultSortId: 'sensor-device-id',
	sortOrder: 0,
};
